import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { ChangeDetectionStrategy, Component, computed, effect, ElementRef, input, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatError, MatFormField, MatHint, MatLabel, MatPrefix, MatSuffix } from '@angular/material/select';
import { EnpsControlComponent } from '@common/controls/enps-control/enps-control';
import { LinkyModule } from 'ngx-linky';

import { ClickStopPropagationDirective } from '../../directives/stop-propagation';
import { HighlightPipe } from '../../pipes/highlight';
import { UnsafePipe } from '../../pipes/unsafe';

@Component({
    selector: 'st-text-area',
    imports: [CdkTextareaAutosize, ClickStopPropagationDirective, FormsModule, HighlightPipe, LinkyModule, MatError, MatFormField, MatHint, MatInput, MatLabel, MatPrefix, MatSuffix, UnsafePipe],
    templateUrl: './st-text-area.html',
    styleUrl: './st-text-area.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-text-area',
    },
})
export class StTextAreaComponent extends EnpsControlComponent<string> {
    readonly textToHighlight = input<string>('');
    readonly showLinks = input(false, {
        transform: coerceBooleanProperty,
    });

    readonly display = viewChild<ElementRef<HTMLDivElement>>('display');
    readonly inEditMode = signal(true);
    readonly internalValue = signal<string>('');

    readonly displayValue = computed(() => {
        return String(this.internalValue() || '') || '';
    });

    readonly displayPlaceholder = computed(() => {
        return this.required() ? this.placeholder() + '*' : this.label() || this.placeholder();
    });

    constructor() {
        super();
        effect(() => {
            this.inEditMode.set(!this.showLinks());
            this.internalValue.set(this.value());
        });
    }

    onNgModelChanged(value: string) {
        this.internalValue.set(value);
    }

    onValueChanged() {
        this.changed.emit(this.internalValue());
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onBlur() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(false);
        }
    }

    onFocus() {
        if (this.showLinks() && !this.disabled()) {
            this.inEditMode.set(true);
        }
    }

    onScroll(event) {
        this.display().nativeElement.scrollTop = event.target.scrollTop;
    }
}
